/**
 * WordPress dependencies
 */
export { __unstableStripHTML as stripHTML, focus } from '@wordpress/dom';
